//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { LeadsContext } from "../context/LeadsContext";
import { ChevronLeft, ChevronRight } from "lucide-react";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerPageNavigation() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { leads, setLeads } = useContext(LeadsContext);
    const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
    const { currentPage, setCurrentPage } = useContext(LeadsContext);
    const { total, setTotal } = useContext(LeadsContext);



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            <div className="flex justify-between items-center text-sm text-ink-3 mt-4">
                <div>
                    {leads.length > 0 ? (
                        `${(currentPage - 1) * itemsPerPage + 1}–${Math.min(currentPage * itemsPerPage, total)} de ${total}`
                    ) : (
                        "Nenhum resultado"
                    )}
                </div>
                <div className="flex items-center gap-3">
                    <select
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        className="bg-surface-2 border border-white/[0.08] p-1 rounded"
                    >
                        {[10, 20, 50].map((n) => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        className="disabled:opacity-40"
                    >
                        <ChevronLeft className="w-4 h-4" />
                    </button>
                    <button
                        disabled={currentPage * itemsPerPage >= total}
                        onClick={() => setCurrentPage(p => p + 1)}
                        className="disabled:opacity-40"
                    >
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </div>
            </div>

        </>
    )
}